import { createContext } from "react";

/** One grid row shares its tallest natural header height, independently of other rows. */
export function createSurfaceHeaderRow(width = 0) {
  const heights = new Map<string, number>();
  const listeners = new Set<() => void>();
  return {
    getHeight: () => Math.max(0, ...heights.values()),
    setHeight(key: string, height: number) {
      if (heights.get(key) === height) {
        return;
      }
      heights.set(key, height);
      for (const listener of listeners) {
        listener();
      }
    },
    subscribe(listener: () => void) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    width,
  };
}

export const SurfaceHeaderRowContext = createContext<{
  itemKey: string;
  row: ReturnType<typeof createSurfaceHeaderRow>;
} | null>(null);
